
import CreateSaleOrderLine from './create-sales-order-line'
export default class CreateSaleOrderDto {
    clientCode: string;
    customerCode: string;
    customerName: string;
    customerPhone: string;
    shippingProvinceId: number;
    shippingDistrictId: number | null;
    shippingWardId: number | null;
    shippingAddressNo: string;
    warehouseCode: string;
    bizType: string;
    externalCode: string;
    shippingServiceCode: string;
    tplCode: string;
    parentCode: number;
    isClientPickup: boolean;
    isNoPack: boolean;
    isLabelling: boolean;
    isShippable: boolean;
    outboundMode: string;
    inventModel:string;
    cod:number=0;
    shippingFee:number=0;
    packingNote: string;
    shippingNote: string;
    shippingFullAddress : string;
    markPreOrder: boolean;
    note: string;
    assetTypeCode :string;
    conditionTypeCode :string;
    items:Array<any>;
}
